import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from '../i18n/I18nContext';
import QoldoLogo from './QoldoLogo';
import { useViewportHeight, useLockBodyScroll } from '../hooks/useViewportHeight';

/**
 * Final closing screen - no way back to the course
 * Shown after completion + feedback (or skip)
 */
export default function ClosedScreen() {
  const { t } = useTranslation();
  
  // iOS Safari viewport height fix
  useViewportHeight();
  useLockBodyScroll(true);
  
  return (
    <div className="player-root bg-gradient-to-br from-green-600 to-teal-600">
      <div className="player-content">
        <div className="text-center text-white px-4">
          {/* Logo with transparent background - white card for visibility on green */}
          <div className="bg-white/95 rounded-xl p-4 mb-6 inline-block shadow-lg">
            <QoldoLogo maxWidth="140px" />
          </div>
          
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
            <CheckCircle2 className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold mb-3">{t('closed_title')}</h1>
          <p className="text-base opacity-90">
            {t('closed_body')}
          </p>
        </div>
      </div>
    </div>
  );
}
